<template>
    <div id="residences" class="residences" v-if="showResidence">
      <div class="view-section scrollFade">
        <div class="view-section--image" :style="{ backgroundImage: `url('${data[0].image}')` }"></div>
      </div>
      <!-- section text image -->
      <div class="left-section">
        <div class="left-section__description">
          <span class="left-section__description--text scrollFadeText">
            {{ data[1].text }}
          </span>
        </div>
        <div class="left-section__view scrollFade">
          <div class="left-section__view--image" :style="{ backgroundImage: `url('${data[1].image}')` }"></div>
        </div>
      </div>
      <!-- section text image -->
      <div class="left-section">
        <div class="left-section__description">
          <span class="left-section__description--text scrollFadeText">
            {{ data[2].text }}
          </span>
        </div>
        <div class="left-section__view scrollFade">
          <div class="left-section__view--image residences-02" :style="{ backgroundImage: `url('${data[2].image}')` }"></div>
<!--          <img class="left-section__view&#45;&#45;img" src="../assets/residences/kitchen.jpg" alt="kitchen">-->
        </div>
      </div>
      <!-- section image text -->
        <div class="left-section residences-scroll">
            <div id="lastSection" class="left-section__view residences-scroll-images scrollFade">
                <img v-for="(image, index) in data[3].images" :key="index" class="left-section__view--img" :src="image.imagePath">
            </div>
            <div class="left-section__description reverse">
                <span class="left-section__description--text">
                  {{ data[3].text }}
                </span>
            </div>
        </div>

        <!-- Carousel -->
        <div class="residences-carousel scrollFade">
            <carousel :per-page="1"  :mouse-drag="false">
                <slide>
                    <img class="residences-carousel--img" :src="data[3].images[0].imagePath">
                </slide>
                <slide>
                    <img class="residences-carousel--img" :src="data[3].images[1].imagePath">
                </slide>
            </carousel>
            <div class="left-section__description reverse">
                <span class="left-section__description--text">
                  {{ data[3].text }}
                </span>
            </div>
        </div>
    </div>
</template>

<script>
    // eslint-disable-next-line no-unused-vars
    const dataLayer = window.dataLayer || [];
    dataLayer.push({
        'event': 'PageView',
        'pagePath': '/residences',
        'pageTitle': 'Parker West | Residences'
    })
    import { Carousel, Slide } from 'vue-carousel';
    export default {
      name: "Residences",
      components: {
        Carousel,
        Slide
      },
      created() {
          if(window.innerWidth <= 600) {
              let myMain = document.getElementsByClassName('app-main')[0];
              myMain.scrollTop = 0;
          }
          // if (newValue) {
          //     setTimeout(() => {
          //         this.showResidence = true
          //     }, 300)
          // }
          if (this.data) {
              setTimeout(() => {
                  this.showResidence = true
              }, 300)
          }
      },
        data: () => ({
            showResidence: false
        }),
        metaInfo: {
            // Define meta tags here.
            titleTemplate: '%s ← Residences',
            meta: [
                {name: 'description', content: 'Parkerwest residences page'}
            ],
            link: [
                {rel: 'canonical', href: 'http://test.parkerwest.com/'}
            ]
        },
        mounted() {
        document.addEventListener('mousewheel', (e) => {
          this.handleScroll(e)
        }, { passive: false })
      },
      // beforeDestroy () {
      //   document.removeEventListener('mousewheel', this.handleScroll);
      // },
      computed: {
        data() {
            return window.data.residences;
        },
      },
      methods: {
        handleScroll(evt) {
          const elmnt = document.getElementsByTagName("html")[0];
          if (!evt) evt = event;
          const direction = (evt.detail<0 || evt.wheelDelta>0) ? 1 : -1;
          // Use the value as you will
          const test = document.getElementById('lastSection')
          if (test) {
            if ((window.innerHeight + window.scrollY) >= elmnt.offsetHeight) {
              // you're at the bottom of the page
              if (direction === -1) {
                elmnt.classList.add('disable' );
                test.scrollLeft   += 30
              }
              if (direction === 1) {
                test.scrollLeft   -= 30
              }

              if (test.scrollLeft <= 0) {
                elmnt.classList.remove('disable' );
              }
              return
            }
          }
          if (direction === 1) {
            elmnt.classList.remove('disable' );
          }

          let slidesTitle = document.getElementsByClassName("scrollFadeText");
            let slides = document.getElementsByClassName("scrollFade");

          for (let i = 0; i < slidesTitle.length; i++) {
            let elPos = slidesTitle[i].getBoundingClientRect().top
            if(elPos < 120) {
              slidesTitle[i].style.opacity = (elPos / 120)
            } else {
              slidesTitle[i].style.opacity = 1
            }
            if ((elPos - innerHeight) < innerHeight && slidesTitle[i].offsetHeight + elPos > innerHeight ) {
              slidesTitle[i].style.opacity = 1 - (elPos / innerHeight)
            }
          }
            if(window.innerWidth > 1199) {
                for (let i = 0; i < slides.length; i++) {
                    let elPos = slides[i].getBoundingClientRect().top
                    const header = document.getElementById('header')
                    if ((elPos - innerHeight) < innerHeight && slides[i].offsetHeight + elPos > innerHeight ) {
                        slides[i].style.opacity = 1 - ((elPos - header.offsetHeight) / innerHeight)
                    }
                }
            }
        }
      }
    }
</script>

<style scoped>
</style>
